var map = {
	"./de.json": [
		4504,
		504
	],
	"./en.json": [
		9301,
		301
	],
	"./fr.json": [
		1470,
		470
	],
	"./it.json": [
		3132,
		132
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3033;
module.exports = webpackAsyncContext;